
<section
  class="w-full flex flex-row justify-center contact-us-outer-container"
  aria-labelledby="contact-us-heading"
>
  <div
    class="flex flex-col lg:flex-row justify-center lg:justify-between items-center w-full mx-5 font-rubik max-w-1216"
  >
    <div class="flex flex-col gap-6 mb-12 lg:mb-0">
      <h2 id="contact-us-heading" class="service-area-contact-us-h2">
        Have questions or<br />
        need assistance?
      </h2>

      <p class="service-area-contact-us-p">
        Our customer support team is ready to assist you with any questions
        or concerns. Contact us via phone, and we'll ensure you find the
        perfect container solution.
      </p>

      <div class="flex gap-8 lg:gap-4 items-center">
        <a
          v-if="phone"
          :href="`tel:${phone}`"
          class="service-area-phone-a"
          :aria-label="`Call us at ${formatPhoneNumber(phone)}`"
        >
          {{ formatPhoneNumber(phone) }}
        </a>
      </div>
    </div>

    <figure class="service-area-img">
      <img
        :src="organizationLogo"
        :alt="`${organization.name} logo`"
        class="service-area-img"
        loading="lazy"
      />
      <figcaption class="sr-only">
        {{ organization.name }}
      </figcaption>
    </figure>
  </div>
</section>
